import React, {useState} from 'react'
import { LinearProgress, ButtonGroup,FormHelperText,Avatar,Typography,
    Button, Box, Checkbox, InputLabel, TextField, Select, MenuItem,
     FormControl, FormControlLabel,  } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import * as firebase from 'firebase';
import _ from 'lodash'
import AdditionalForm from './AdditionalForm';
import { Alert} from '@material-ui/lab';
import ReactGA from 'react-ga';
import OtherFields from './OtherFields';

const useStyles = makeStyles((theme)=>({
    input:{
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      width: '100%'
    },
    successContainer:{
        marginTop: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent:'center'
    },
    icon: {
      
      height: '80px',
      width: '80px',
      marginBottom: theme.spacing(4)
    },
    button:{
      color: theme.palette.text.secondary,
      fontFamily: 'ShameimaruSans',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      width: '100%'
  },
    buttonSecondary:{
        color: theme.palette.text.secondary,
       
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
     
    },
    progress:{
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
      },
    buttonGroup:{
      marginTop: theme.spacing(2)
    }, 
    viewButtonLabel:{
      textTransform: 'none'
    },
    box:{
        display:'flex',
        justifyContent:'center'
    },
  }));





export default function VotingScreen(props) {
    const classes = useStyles()
    let db = firebase.firestore()
    let analytics= firebase.analytics()
    const [hasAnswered, setHasAnswered] = useState(false)
    const [answer, setAnswer] = useState()
    const theme = useTheme()

    const answerMap = {
      'tankstellen':'Ich möchte bei einer anderen Tankstelle tanken',
      'zeit': 'Ich habe aktuell noch einen vollen Tank',
      'zeitraum': 'Reservierungszeitraum ist zu kurz',
      'preis': 'Ich weiß nicht ob der Preis gerade günstig ist',
      'other': 'Anderer Grund/Sonstiges'
    }


    const handleButtonClick = (selected) =>{
        analytics.logEvent('feedback', {answer: answerMap[selected]})
        // ReactGA.event({category:'feedback',action:selected})
            db.collection('votes').add({
              type:selected,
              time: new Date()
            }).then(()=>{
                setAnswer(selected)
                setHasAnswered(true)
          })
        }
        const handleBack= ()=>{
            props.setStation()
            props.changePage(1)
        }


    return (
        <React.Fragment>
        {!hasAnswered?
        <React.Fragment>
        <Typography style={{fontFamily: 'ShameimaruSansAlternatives', paddingBottom: theme.spacing(2)}} variant='h5' color='textPrimary'>
        {answer=='tankstellen'?'Wo würdest du gerne tanken?':'Wir freuen uns über dein Feedback'}
        </Typography>
        <LinearProgress variant="determinate" value={100} color='secondary'/>
        </React.Fragment>
        :<React.Fragment>
        <Typography style={{fontFamily: 'ShameimaruSansAlternatives', paddingBottom: theme.spacing(2)}} variant='h5' color='textPrimary'>
        {answer=='tankstellen'?'Wo würdest du gerne tanken?':'Wir freuen uns über dein Feedback'}
        </Typography>
        <LinearProgress variant="determinate" value={100} color='secondary'/>
        </React.Fragment>}
        {!answer?
        <React.Fragment>
        <ButtonGroup  className={classes.buttonGroup} size='medium' orientation='vertical' fullWidth color="secondary" >
              <Button onClick={()=>handleButtonClick('tankstellen')} classes={{ label: classes.viewButtonLabel }}>Ich möchte bei einer anderen Tankstelle tanken</Button>
              <Button onClick={()=>handleButtonClick('zeit')} classes={{ label: classes.viewButtonLabel }}>Ich habe aktuell noch einen vollen Tank</Button>
              <Button onClick={()=>handleButtonClick('zeitraum')} classes={{ label: classes.viewButtonLabel }}>Reservierungszeitraum ist zu kurz</Button>
              <Button onClick={()=>handleButtonClick('preis')} classes={{ label: classes.viewButtonLabel }}>Ich weiß nicht, ob der Preis gerade günstig ist</Button>
              <Button onClick={()=>handleButtonClick('other')} classes={{ label: classes.viewButtonLabel }}>Anderer Grund</Button>
        </ButtonGroup>
        <Box className={classes.box}>
        <Button onClick={()=>handleBack()} variant='text' className={classes.buttonSecondary}>Zurück</Button>
        </Box>
        </React.Fragment>:
        answer=='tankstellen'?
        <AdditionalForm answerMap={answerMap} changePage={props.changePage} setHasAnswered={setHasAnswered} answer={answer} setAnswer={setAnswer} setStation={props.setStation}/>:
        <OtherFields answerMap={answerMap} changePage={props.changePage} setHasAnswered={setHasAnswered} answer={answer} setAnswer={setAnswer} setStation={props.setStation}/>
        }
        
        </React.Fragment>
    )
}
